import { MasterHelper } from '../../utilities';
import { FilterViewModel } from '../regulation';

export class SelfAssessmentT2MasterFilter {
    fromDate!: Date|null;
    toDate!: Date|null;
    assessmentTeam: FilterViewModel[];
    assessmentStatus: FilterViewModel[];
    complianceStatus: FilterViewModel[];
    reviewerTeam: FilterViewModel[];
    reviewStatus: FilterViewModel[];
    interpretation: FilterViewModel[];
    judgement: FilterViewModel[];
    gaps: FilterViewModel[];
    enhancement: FilterViewModel[];
    approvalTeam: FilterViewModel[];
    approvalStatus: FilterViewModel[];
    owner: FilterViewModel[];

    constructor() {
        this.fromDate = null;
        this.toDate = null;
        this.assessmentTeam = [];
        this.reviewerTeam = [];
        this.assessmentStatus = [];
        this.reviewStatus = [];
        this.complianceStatus = [];
        this.interpretation = [];
        this.judgement = [];
        this.owner = [];
        this.gaps = [];
        this.enhancement = [];
        this.approvalStatus = [];
        this.approvalTeam = [];
    }
}
